import { axios } from './config'
import { proxyApi } from './common'
import { FormApi } from './config'
function memberApi(target, data) {
    return proxyApi('membership', ...arguments)
}

//会员信息
export const getMemberInfo = async () => {
    return await memberApi('GetMember')
}
//更新会员信息
export const updateMember = async (input) => {
    return await memberApi('UpdateMember', {
        input,
        isPartialUpdate: true,
    })
}
export function getAddress() {
    return axios.get(FormApi + '/preset/address.json')
}
// 礼品列表
export const getProducts = async (index = 1, size = 999) => {
    return await memberApi('GetProducts', {
        index,
        size,
    })
}
// 礼品列表
export const getProduct = async (productId) => {
    return await memberApi('GetProduct', {
        productId,
    })
}

// 兑换
export const placeOrder = async (input) => {
    return await memberApi('PlaceOrder', {
        input,
    })
}
// 获取收藏
export const getBookmarks = async (index = 1, size = 999, desc = true) => {
    return await memberApi('GetBookmarks', {
        index,
        size,
        desc,
    })
}

// 添加收藏
export const addBookmark = async (input) => {
    return await memberApi('AddBookmark', {
        input,
    })
}
// 取消收藏
export const deleteBookmark = async (bookmarkId) => {
    return await memberApi('DeleteBookmark', {
        bookmarkId,
    })
}
// 获取收件人
export const getRecipients = async (index = 1, size = 999, desc = true) => {
    return await memberApi('GetRecipients', {
        index,
        size,
        desc,
    })
}
// 删除收件人
export const deleteRecipient = async (recipientId) => {
    return await memberApi('DeleteRecipient', {
        recipientId,
    })
}
// 收件人详情
export const getRecipient = async (recipientId) => {
    return await memberApi('GetRecipient', {
        recipientId,
    })
}
// 更改/新增收件人
export const updateRecipient = async (input, recipientId) => {
    if (recipientId) {
        return await memberApi('UpdateRecipient', {
            recipientId,
            input,
        })
    } else {
        return await memberApi('AddRecipient', {
            input,
        })
    }
}
// 积分商城设置
export const getPointStoreSetting = async () => {
    return await memberApi('GetPointStoreSetting')
}

// 成为会员表单设置
export const getMembershipLevelSettings = async () => {
    return await memberApi('GetMembershipLevelSettings')
}
